import { create } from 'zustand';
import {
  createJSONStorage,
  persist,
  // subscribeWithSelector,
} from 'zustand/middleware';

interface EventProperties {
  properties: any;
  setProperties: (value) => void;
}
export const useEventPropertiesStore = create<EventProperties>((set) => ({
  properties: { url: '', path: '' },
  setProperties: (value) => set({ properties: value }),
}));

interface WindowPosition {
  xPercent: number;
  yPercent: number;
}

interface WindowSize {
  width: number;
  height: number;
}

interface MediaWindowLocationInfo {
  key: string;
  position: WindowPosition;
  size: WindowSize;
}

interface MediaWindowStore {
  mediaInfoMap: Map<string, MediaWindowLocationInfo>;
  saveWindowPosition?: (key: string, value: WindowPosition) => void;
  saveWindowSize?: (key: string, value: WindowSize) => void;
}

interface StorageValue {
  dataType: string;
  value: [string, MediaWindowLocationInfo][];
}

const storage = createJSONStorage<MediaWindowStore>(() => sessionStorage, {
  // 저장할 때 실행: Map을 배열로 변환
  replacer: (key, value: StorageValue) => {
    if (value instanceof Map) {
      return {
        dataType: 'Map',
        value: Array.from(value.entries()),
      };
    }
    return value;
  },
  // 불러올 때 실행: 배열을 Map으로 복원
  reviver: (key, value: StorageValue) => {
    if (
      typeof value === 'object' &&
      value !== null &&
      value.dataType === 'Map'
    ) {
      return new Map(value.value);
    }
    return value;
  },
});

export const useMediaWindowInfoStore = create(
  persist<MediaWindowStore>(
    (set) => ({
      mediaInfoMap: new Map<string, MediaWindowLocationInfo>(),
      saveWindowPosition: (key: string, value: WindowPosition) =>
        set((prev) => {
          const newMap = new Map(prev.mediaInfoMap);
          const existingMedia = newMap.get(key);

          newMap.set(key, {
            ...existingMedia,
            key,
            position: value,
          });

          return { mediaInfoMap: newMap };
        }),
      saveWindowSize: (key: string, value: WindowSize) =>
        set((prev) => {
          const newMap = new Map(prev.mediaInfoMap);
          const existingMedia = newMap.get(key);

          newMap.set(key, {
            ...existingMedia,
            key,
            size: value,
          });

          return { mediaInfoMap: newMap };
        }),
    }),
    {
      name: 'media-window-storage',
      storage: storage,
      partialize: (state) => ({ mediaInfoMap: state.mediaInfoMap }),
    },
  ),
);

// TODO: 온보딩 메시지 상태 관리
// interface ManageOnboardingMessage {
// }
// export const useOnboardingMessageStore = create(
//   subscribeWithSelector(
//     persist<ManageOnboardingMessage>((set) => ({}), {
//       name: 'manage-onboarding-storage',
//       storage: createJSONStorage(() => localStorage),
//     }),
//   ),
// );
